import React from 'react';
import { Button } from 'antd';

const SaveAsDraftButton = ({ htmlType, ...rest }) => {
	return (
		<Button
			{...rest}
			type="default"
			htmlType={htmlType}
		>
			Save as Draft
		</Button>
	);
};

export default SaveAsDraftButton;